export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1753_.56418224.jpg";